<template><!-- svgo-optimised -->
<svg class="icon icon__pause" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 5h3v14H7zM14 5h3v14h-3z"/></svg></template>